var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "24px",
    viewBox: "0 0 38 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VISA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEEZ_PSP_UI_Icons",
    transform: "translate(-266.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VISA",
    transform: "translate(266.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#0353A5",
    x: 0,
    y: 0,
    width: 38,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9876304,7 L30.0438567,7 C29.4439063,7 28.9874869,7.18132244 28.731338,7.8350397 L25,17.0592212 L27.6375593,17.0592212 C27.6375593,17.0592212 28.0688568,15.8164695 28.1625355,15.5510919 L31.3876017,15.5510919 C31.4624194,15.9070902 31.6874986,17.0592212 31.6874986,17.0592212 L34.0125609,17.0592212 L31.9876304,7 Z M28.8875473,13.4925918 C29.0939221,12.9166073 29.8875691,10.6768658 29.8875691,10.6768658 C29.8750473,10.6962382 30.0938656,10.0877502 30.2188488,9.71229844 L30.3937626,10.5797606 C30.3937626,10.5797606 30.8688081,12.9877745 30.9750868,13.4926728 L28.8875473,13.4926728 L28.8875473,13.4925918 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8250471,7 L9.36881899,13.8616401 L9.09999174,12.4698262 L8.22495315,7.84792762 C8.08118731,7.20709828 7.63744625,7.02585689 7.08742647,7 L3.04382628,7 L3,7.20069485 C3.98749995,7.45966901 4.86879943,7.83512076 5.63748103,8.30759663 L7.87504728,17.0464954 L10.5312327,17.0464954 L14.4811543,7 L11.8250471,7 L11.8250471,7 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "15.568746 7 14 17.0593023 16.5063935 17.0593023 18.0813221 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0687438,11.220671 C22.1875226,10.761083 21.6500246,10.450314 21.6500246,9.97783815 C21.6624681,9.55059157 22.1062092,9.11037602 23.0937874,9.11037602 C23.9124779,9.09092256 24.5125066,9.29169846 24.9624303,9.49223119 L25.1875095,9.60230535 L25.5312327,7.42732764 C25.0374045,7.22655173 24.2500185,7 23.281223,7 C20.8000296,7 19.0562915,8.37244149 19.0437698,10.3272709 C19.0249871,11.7707986 20.2936795,12.573578 21.2436924,13.0589417 C22.2124879,13.55079 22.5436893,13.874609 22.5436893,14.3082591 C22.5312458,14.9815919 21.7561468,15.2922798 21.0373958,15.2922798 C20.0374523,15.2922798 19.4998761,15.1303298 18.6813421,14.7551212 L18.3499841,14.5930901 L18,16.852204 C18.5873504,17.1306317 19.6749464,17.3766368 20.7999513,17.3897089 C23.4374323,17.3960092 25.156205,16.0430212 25.1749095,13.9587453 C25.1875878,12.8130987 24.5125848,11.939152 23.0687438,11.220671 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/VISA.8fb06546.svg";
export { ForwardRef as ReactComponent };